import { Component, Injector } from '@angular/core';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { BaseView } from '../../base-view';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent extends BaseView {

  isStep1:boolean;

  constructor(protected _injector: Injector) {
    super(_injector);
    this._injector.get(PageLayoutDataService).init({
      notMobileMaxWidth: 352,
      layoutType: 1,
      verticallyCentered:true,
      showBreadcrumbs:false})

    this.isStep1 = !this._injector.get(RoutingDataService).currentUrlParams.hasOwnProperty("otp");
  }
}